import {
	InfoCircleOutlined,
	SearchOutlined,
	UploadOutlined,
} from '@ant-design/icons';
import { Dropdown, Menu, Select, Space, Switch, Tooltip } from 'antd';
import DateRangePickerField from 'components/Global/BackAndFoewardRangePicker';
import BulkTimeSheetImport from './BulkTimesheetAddModal';
import styles from './index.module.scss';
import SearchComponent from 'components/Global/SearchComponent';
import { useContext } from 'react';
import { PermissionContext } from 'components/Global/AuthLayout';

type Props = {
	statusFilterValue: string;
	handleStatusFilter: (value: string) => void;
	options: any;
	dropdownOptionLoading: boolean;
	handleStaffCodeChange: any;
	staffCode: any;
	handleDatePicker: (value: [string, string]) => void;
	dateValue: [string, string];
	payPeriodOptions: any[];
	payPeriodLoading: boolean;
	currentPayPeriodIndex: number;
	onPayPeriodChange: (index: number, payPeriod: any) => void;
	payrollViewEnabled: boolean;
	onPayrollViewToggle: any;
	payPeriodsForNavigation: any;
	searchText: string;
	handleSearch: (value: string) => void;
};

const EmployeeHeader = (props: Props) => {
	const {
		statusFilterValue,
		handleStatusFilter,
		options,
		dropdownOptionLoading,
		handleStaffCodeChange,
		staffCode,
		payPeriodOptions,
		payPeriodLoading,
		handleDatePicker,
		dateValue,
		// New props
		currentPayPeriodIndex,
		onPayPeriodChange,
		payrollViewEnabled,
		onPayrollViewToggle,
		payPeriodsForNavigation,
		searchText,
		handleSearch,
	} = props;

	const staffCodeOptions = [
		{ label: 'Hourly Employee', value: 'HOURLY' },
		{ label: 'Monthly Employee', value: 'MONTHLY' },
	];
	const { allowedPermissions } = useContext(PermissionContext);
	const isPayrollView = allowedPermissions.includes('Allow_Payroll_Hours');

	const menu = (
			<Menu>
				<BulkTimeSheetImport />
			</Menu>
	);
	return (
		<div className={styles['employee-header']}>
			<Space>
				<SearchComponent
					className={styles['employee-header-item']}
					placeHolder="Search by code or name..."
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={() => {}}
					value={searchText}
					size="large"
				/>
				<Space>
					<Select
						className={styles['employee-header-item']}
						value={staffCode}
						options={staffCodeOptions}
						onChange={handleStaffCodeChange}
						size="large"
						style={{ minHeight: '40px', width: '180px' }}
					/>
				</Space>
				{options?.length && staffCode === 'HOURLY' ? (
					<Space>
						<Select
							className={styles['employee-header-item']}
							value={statusFilterValue}
							options={options}
							onChange={(value) => {
								handleStatusFilter(value);
							}}
							size="large"
							placeholder="Select Status"
							loading={dropdownOptionLoading}
							disabled={dropdownOptionLoading}
							style={{ minHeight: '40px', width: '160px' }}
						/>
					</Space>
				) : null}
				<div>
					<DateRangePickerField
						name="payPeriodRange"
						value={dateValue}
						onChange={handleDatePicker}
						showNavigationArrows={true}
						payPeriods={payPeriodOptions.map((period: any) => ({
							id: period.id,
							name: period.name,
							value: period.id,
							label: period.name,
							startDate: period.startDate,
							endDate: period.endDate,
						}))}
						currentPayPeriodIndex={currentPayPeriodIndex}
						payPeriodsForNavigation={payPeriodsForNavigation}
						onPayPeriodChange={onPayPeriodChange}
						allowCustomDateSelection={false}
						disabled={payPeriodLoading}
						required={false}
						width={'261px'}
						isError={false}
					/>
				</div>
			</Space>
			{staffCode === 'HOURLY' && isPayrollView && (
				<div className={styles['right-actions']}>
					<div className={styles['payroll-toggle']}>
						<span className={styles['payroll-label']}>
							Payroll View
						</span>
						<Switch
							checked={payrollViewEnabled}
							onChange={onPayrollViewToggle}
							checkedChildren=""
							unCheckedChildren=""
							style={{
								backgroundColor: payrollViewEnabled
									? '#584495'
									: '',
							}}
						/>
						<Tooltip
							title={
								<div className={styles['tooltip-content']}>
									<div>
										<strong>ON :</strong> Hours calculated
										based on 208 standard working hours per
										month for payroll processing
									</div>
									<div>
										<strong>OFF :</strong> Hours calculated
										based on actual logged working hours
									</div>
								</div>
							}
						>
							<InfoCircleOutlined
								className={styles['info-icon']}
							/>
						</Tooltip>
					</div>

					{staffCode === 'HOURLY' && (
						<div className={styles['upload-box']}>
							<Dropdown overlay={menu} trigger={['click']}>
								<p className={styles['menu-icon']}>
									<span className={styles['upload-icon']}>
										<UploadOutlined />
									</span>
								</p>
							</Dropdown>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default EmployeeHeader;
